import { render, staticRenderFns } from "./WhiteListDelete.vue?vue&type=template&id=a3de02d6&"
import script from "./WhiteListDelete.vue?vue&type=script&lang=js&"
export * from "./WhiteListDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports